module.exports = __webpack_public_path__ + "public/1.0.1_896977/img/paperclip.421d306e.png";